import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
  ongoingOrders: [],
  acceptedOrders: [],
  scheduledOrders: [],
  completedOrders: [],
  cancelledOrders: [],
  ongoingOrdersLoading: false,
  acceptedOrdersLoading: false,
  completedOrdersLoading: false,
  scheduledOrdersLoading: false,
  cancelledOrdersLoading: false,
  doneOrderBtnLoading: false,
  cancelOrderBtnLoading: false,
  professionalPaymentLoading: false,
  unsubscribe: {},
  leadsexhausted: false,
  lastDoc: null,
  limit: 10,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ORDERS_CONTROLS:
      return updateObject(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
